type StorageType = 'local' | 'session';

function getStorage(type: StorageType): Storage | null {
  try {
    return type === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export function safeGetItem(type: StorageType, key: string): string | null {
  return getStorage(type)?.getItem(key) ?? null;
}

export function safeSetItem(type: StorageType, key: string, value: string): void {
  getStorage(type)?.setItem(key, value);
}

export function safeRemoveItem(type: StorageType, key: string): void {
  getStorage(type)?.removeItem(key);
}
